import { render, staticRenderFns } from "./SetupPlanBeward.vue?vue&type=template&id=a1fde866&scoped=true"
import script from "./SetupPlanBeward.vue?vue&type=script&lang=js"
export * from "./SetupPlanBeward.vue?vue&type=script&lang=js"
import style0 from "./SetupPlanBeward.vue?vue&type=style&index=0&id=a1fde866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fde866",
  null
  
)

export default component.exports